import React from "react";
import { Button, Link, Stack, Typography } from "@mui/material";
import { ArrowRight, CalendarX, HouseLine } from "@phosphor-icons/react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

export const STEPS = {
  makeupDay: "makeup-day",
  recommendations: "recommendations",
  customDate: "custom-date",
  review: "review-appointment",
  confirmation: "confirmation",
  rescheduleConfirmation: "reschedule-confirmation",
  cancellationReview: "cancellation-review",
  cancellationConfirmation: "cancellation-confirmation",
  rescheduleWindowClosed: "window-closed",
  noAppointments: "no-appointments",
  // ANOW-6441: no candidate time works for both the primary and supervisory clinician.
  supervisorUnavailable: "supervisor-unavailable",
  appointmentRemoved: "appointment-removed",
  somethingWentWrong: "something-went-wrong",
};

export const GoHomePrimary = () => {
  const { t } = useTranslation(["rescheduling"]);
  const history = useHistory();
  return (
    <Button
      size="large"
      startIcon={<HouseLine weight="duotone" />}
      onClick={() => history.push("/dashboard")}
    >
      {t("rescheduling:common.goHome")}
    </Button>
  );
};

export const LinkAndCancelButton = ({ LinkLabel, onClickLink, onCancel }) => {
  const { t } = useTranslation(["rescheduling"]);
  return (
    <>
      <Link underline="none" onClick={onClickLink}>
        <Stack direction="row" gap={1} alignItems="center">
          <Typography variant="body1">{LinkLabel}</Typography>
          <ArrowRight size={20} />
        </Stack>
      </Link>
      <Button
        size="large"
        color="error"
        variant="text"
        startIcon={<CalendarX />}
        onClick={onCancel}
      >
        {t("rescheduling:common.cancelAppointment")}
      </Button>
    </>
  );
};
